module.exports = __webpack_public_path__ + "img/book3.ac1f2f2a.png";